import Table from 'antd/lib/table'
import './index.less'

export default Table



// WEBPACK FOOTER //
// ./src/elements/table/index.js